export default {
    init() {
        this.event();
    },
    event() {  
        $(window).on('scroll', function () {
            let winScroll = document.body.scrollTop || document.documentElement.scrollTop,
                header = $('.c-header');

            if (winScroll > header.height() * 4) {
                header.addClass('js-fixed');
            }
            else {
                header.removeClass('js-fixed');
            }
        });
    },
}



// WEBPACK FOOTER //
// ./scripts/components/scroll.js